module.exports = __webpack_public_path__ + "img/bitu-sad.3d71d217.jpg";